export default function AboutCompany() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          {/* Text Content */}
          <div>
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              Leading Provider of Cardiac & Diabetic Medicines
            </h2>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              Ester LifeSciences is a distinguished pharmaceutical company specializing in sourcing and distributing premium quality medicines for cardiac, diabetic, and chronic disease management. We have been committed to improving healthcare outcomes through excellence in pharmaceutical distribution.
            </p>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              Our comprehensive portfolio includes cardiovascular medicines, diabetic care products, and quality pharmaceutical solutions that meet the highest international standards. We work closely with healthcare professionals to ensure optimal patient care and treatment outcomes.
            </p>
            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              With ISO 9001:2015 certification and WHO-GMP compliance, we maintain rigorous quality standards across our entire supply chain. Our dedication to pharmaceutical excellence has made us a trusted partner for healthcare providers across the region.
            </p>

            {/* Statistics */}
            <div className="grid grid-cols-3 gap-8">
              <div>
                <div className="text-4xl font-bold text-teal-600 mb-2">500+</div>
                <div className="text-sm text-gray-600">Healthcare Partners</div>
              </div>
              <div>
                <div className="text-4xl font-bold text-teal-600 mb-2">28</div>
                <div className="text-sm text-gray-600">Quality Products</div>
              </div>
              <div>
                <div className="text-4xl font-bold text-teal-600 mb-2">15+</div>
                <div className="text-sm text-gray-600">Years Experience</div>
              </div>
            </div>
          </div>

          {/* Image */}
          <div>
            <div className="rounded-3xl overflow-hidden shadow-xl w-full h-[600px]">
              <img
                src="/assets/AboutCompany.jpg"
                alt="Ester LifeSciences Pharmaceutical Facility"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
